module.exports = function getResource(label, vars = []) {
    const resources = {
        defaultCard: 'Carte par défaut',
        expires: 'Expire le',
        payPalAccount: 'Compte PayPal',
        payWithPayPal: 'Payer avec PayPal',
        payWithApplePay: 'Payer avec ApplePay',
        payWithKlarna: `Payez en quatre versements sans intérêt de ${vars[0]}`,
        payWithAfterpay: `Payez en quatre versements sans intérêt de ${vars[0]}`,
        storeCreditApplied: 'Crédit au compte appliqué',
        endingIn: 'se terminant par',
        paymentDisabled: `${vars[0]} ne peut pas être utilisée pour les achats de cartes-cadeaux, de Flash, d’abonnements ou de rendez-vous en magasin, pour les récompenses Carte de crédit Sephora, ni pour les commandes de ${vars[1]} ou plus.`,
        paymentGiftCardMessage: `Les cartes-cadeaux ne peuvent être combinées à ${vars[0]}. Si vous voulez utiliser une carte-cadeau, veuillez choisir un autre mode de paiement.`
    };

    return resources[label];
};
